import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PremiumSidebar from "./PremiumSidebar";
import { profileAvatar } from "../component/ImageList";
import stringsoflanguages from "../component/stringsoflanguages";

const PREMIUM_SIDEBAR_PATHS = {
    "Premium Members": "/premium-home/premium-members",
    "Consumer Apps Active": "/premium-home/consumer-apps-active",
    "Consumer App Settings": "/premium-home/consumer-app-settings",
    "Info Requests": "/premium-home/info-requests",
    "Listing Match": "/premium-home/listing-match",
    "Custom App Store": "/premium-home/custom-app-store",
};

function pathForPremiumSidebarActive(activeLabel) {
    if (!activeLabel) return PREMIUM_SIDEBAR_PATHS["Info Requests"];
    if (PREMIUM_SIDEBAR_PATHS[activeLabel]) return PREMIUM_SIDEBAR_PATHS[activeLabel];
    if (activeLabel === stringsoflanguages.listingMatch) return "/premium-home/listing-match";
    return PREMIUM_SIDEBAR_PATHS["Info Requests"];
}

function normalizeDisplayValue(value) {
    if (value == null) return "";
    const normalized = String(value).trim();
    if (!normalized) return "";
    const lowered = normalized.toLowerCase();
    if (lowered === "null" || lowered === "undefined") return "";
    return normalized;
}

export default function ConsumerProfile() {
    const navigate = useNavigate();
    const location = useLocation();
    const consumer = location.state?.consumer_details || {};

    const [activeItem] = useState(() => location.state?.premiumSidebarActive || "Info Requests");
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    useEffect(() => {
        if (window.innerWidth <= 767) {
            setIsMobilePageOpen(true);
        }
    }, []);

    useEffect(() => {
        document.body.classList.add("premium-page");
        return () => {
            document.body.classList.remove("premium-page");
        };
    }, []);

    const handleItemClick = (item) => {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: item === "Premium Members" },
            })
        );
        navigate("/premium-home", { state: { initialActiveItem: item } });
    };

    function navigateBackToPremiumSection() {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: activeItem === "Premium Members" },
            })
        );
        const path = pathForPremiumSidebarActive(activeItem);
        navigate(path);
    }

    const handleBackClick = () => {
        navigateBackToPremiumSection();
    };

    const firstName = normalizeDisplayValue(consumer?.fname);
    const lastName = normalizeDisplayValue(consumer?.lname);
    const fullName = `${firstName} ${lastName}`.trim() || "N/A";
    const email = normalizeDisplayValue(consumer?.email) || "N/A";
    const phone = normalizeDisplayValue(consumer?.phone) || "N/A";
    const state = normalizeDisplayValue(consumer?.state_name);
    const city = normalizeDisplayValue(consumer?.city_name);
    const country = normalizeDisplayValue(consumer?.country_name);
    const locationText = [city, country].filter(Boolean).join(" - ") || "N/A";
    const favCount = normalizeDisplayValue(consumer?.fav_count) || "0";
    const imageUrl = normalizeDisplayValue(consumer?.picture) || profileAvatar;


    return (
        <section className="home">
            <div className="container">
                <div className="content-holder">
                    <PremiumSidebar activeItem={activeItem} setActiveItem={handleItemClick} />
                    <div className={`content-right-wrapper ${isMobilePageOpen ? "mobile-page-open" : ""}`}>
                        {isMobile && isMobilePageOpen && (
                            <div className="mobile-page-header">
                                <button type="button" className="mobile-back-btn" onClick={handleBackClick}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M15 18L9 12L15 6"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    Back
                                </button>
                                <h2 className="mobile-page-title">Consumer profile</h2>
                            </div>
                        )}
                        <div className="content-right">
                            <div className="search-filter-section">
                                <button
                                    type="button"
                                    className="filter-btn"
                                    onClick={navigateBackToPremiumSection}
                                >
                                    Back
                                </button>
                            </div>


                            <div className="members-profile-container consumer-profile-container">
                                <div className="members-profile-header consumer-profile-header">

                                    <div className="members-profile-image-wrapper">
                                        <img
                                            className="members-profile-image"
                                            src={imageUrl || profileAvatar}
                                            alt={`${firstName} ${lastName}`}
                                        />

                                    </div>
                                    <div className="members-profile-info">
                                        <h3 className="members-profile-name">{firstName} {lastName}</h3>
                                        <p className="members-profile-email font-medium">{email}</p>
                                        {/* <p className="member-since mb-0">Member since {membersProfile?.added_date}</p> */}
                                        {/* <p className="members-profile-title">{Title}</p> */}
                                        {/* <p className="members-profile-location">{[city, country].filter(Boolean).join(' - ')}</p> */}
                                        <div className="members-profile-contact-btns">
                                            <Link to={`tel:${phone}`} className="members-profile-contact-btn" aria-label="Call">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                                </svg>
                                            </Link>
                                            <Link to={`mailto:${email}`} className="members-profile-contact-btn" aria-label="Email">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                                    <polyline points="22,6 12,13 2,6" />
                                                </svg>
                                            </Link>
                                            <Link to={`sms:${phone}`} className="members-profile-contact-btn" aria-label="Message">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                                </svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="profile-details">
                                    <div className="detail-section">
                                        <h3 className="section-title">{stringsoflanguages.personalInformation}</h3>
                                        <div className="detail-content">
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.fName}</div>
                                                <div className="detail-value">{firstName}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.lName}</div>
                                                <div className="detail-value">{lastName}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.phone}</div>
                                                <div className="detail-value">{phone}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.country}</div>
                                                <div className="detail-value">{country}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.state}</div>
                                                <div className="detail-value">{state}</div>
                                            </div>
                                            <div className="detail-row">
                                                <div className="detail-label">{stringsoflanguages.city}</div>
                                                <div className="detail-value">{city}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
